/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const prescriptionTemplates = sqliteTable('prescription_templates', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  name: text('name'),
  description: text('description'),
  category: text('category'),
  specialty: text('specialty'),
  diagnosis_code: text('diagnosis_code'),
  diagnosis_label: text('diagnosis_label'),
  default_instructions: text('default_instructions'),
  is_active: integer('is_active'),
  created_by: text('created_by'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
